import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import RequirementBlockCardHeader from '../RequirementBlockCardHeader';

function InsuranceLanguageBlock({ displayName, description, isRequired, isArchived }) {
  return (
    <Box
      backgroundColor={isArchived ? colors.greyScale['200'] : colors.greyScale['100']}
      borderRadius="md"
      flexBasis="100%"
      mb={4}
      px={3}
      py={4}
    >
      <RequirementBlockCardHeader displayName={displayName} isArchived={isArchived} isRequired={isRequired} />
      <Text color={colors.greyScale['700']} mt={3} textAlign="left" textStyle="bodySm">
        {description}
      </Text>
    </Box>
  );
}

InsuranceLanguageBlock.propTypes = {
  displayName: PropTypes.string,
  description: PropTypes.string,
  isRequired: PropTypes.bool,
  isArchived: PropTypes.bool
};

export default InsuranceLanguageBlock;
